import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Card, GroupDivider } from '../components';
import { TablePagination } from '@material-ui/core';

export interface Medicine {
  product: string;
  name: string;
  activeIngredient?: string;
}

interface GroupProps {
  letter: string;
  medicines: Medicine[];
}

const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const HorizontalLine = styled.hr`
  border: none;
  height: 3px;
  background-color: #F3F3F4;
  margin-bottom: 40px;
  opacity: 1;
`;

export function Group({ letter, medicines }: GroupProps) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Reset pagination when the medicines list changes.
  useEffect(() => {
    setPage(0);
    setRowsPerPage(10);
  }, [medicines]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Calculate the slice of data based on the current page and rows per page.
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedMedicines = medicines.slice(startIndex, endIndex);

  return (
    <>
      <GroupDivider letter={letter} />
      <CardsContainer>
        {paginatedMedicines.map((medicine) => (
          <Card key={`${medicine.product}-${medicine.name}`} {...medicine} />
        ))}
      </CardsContainer>
      {medicines.length > rowsPerPage && (
      <TablePagination
        rowsPerPageOptions={[2, 10, 50, 100]}
        component="div"
        count={medicines.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage} // ✅ Novo nome
        onRowsPerPageChange={handleChangeRowsPerPage} // ✅ Novo nome
        style={{ marginRight: '10px' }}
      />
      )}
      <HorizontalLine />
    </>
  );
}
